import { render, staticRenderFns } from "./account_setting.vue?vue&type=template&id=c3706734&scoped=true"
import script from "./account_setting.vue?vue&type=script&lang=js"
export * from "./account_setting.vue?vue&type=script&lang=js"
import style0 from "./account_setting.vue?vue&type=style&index=0&id=c3706734&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3706734",
  null
  
)

export default component.exports